<template>
  <div id="app" class="font-body">
    <header class="print:hidden">
      <div class="container mx-auto text-center border-b border-pink-600 mb-6 max-w-sm">
        <h1 class="font-display text-4xl text-pink-600 my-2">Pocket</h1>
      </div>
    </header>

    <alert-component></alert-component>

    <div v-if="user" id="nav" class="text-center mx-auto mb-6 print:hidden">
      <router-link class="pb-2 mr-6 border-b-2 border-pink-500" to="/">Home</router-link>
      <router-link class="pb-2 mr-6 border-b-2 border-pink-500" to="/transactions">Transaction</router-link>
      <a class="pb-2 border-b-2 border-pink-500" href="#" @click.prevent="logoutUser">Logout</a>
    </div>

    <div class="text-center mx-auto p-3 print:hidden" v-if="loading">
      <font-awesome-icon icon="spinner" class="fa-spin fa-2x text-purple-600" />
      <p class="mt-2 text-2xl text-purple-600 font-display">Loading...</p>
    </div>

    <router-view />
  </div>
</template>

<script>
import alertComponent from "@/components/Alert.vue";

export default {
  methods: {
    logoutUser() {
      this.$store.dispatch("signOut");
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    loading() {
      return this.$store.getters.loading;
    }
  },
  components: {
    alertComponent
  }
};
</script>


<style>
@tailwind base;

@import url("https://fonts.googleapis.com/css?family=Fira+Mono:400,700|Lobster&display=swap");

@tailwind components;

@tailwind utilities;

.showin-enter-active {
  transition: all 0.3s ease-in-out;
}
.showin-enter {
  opacity: 0;
}
</style>
